/* Copyright 2025 Supovia LLC */

'use client'

import { QueryClient } from '@tanstack/react-query'

// The one place the query defaults are written, so a server-rendered tree and
// the browser tree that adopts its cache cannot disagree about them.
//
// It lives in THIS package rather than in the consumer for a resolution reason,
// not a stylistic one: under pnpm's isolated node_modules a consumer that
// imports `@tanstack/react-query` itself can resolve a different copy than the
// one `useWebsite` and friends resolve here. `QueryClientProvider` publishes its
// client on a module-scoped React context, so two copies means the provider
// writes to one context and the hooks read another — and every hook throws
// "No QueryClient set, use QueryClientProvider to set one" despite a provider
// sitting right above it in the tree.
export default function createQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        suspense: true,
      },
    },
  })
}
